document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.quick-add__submit');
  
  // Loop through all "Quick Buy" buttons
  buttons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
        const quickAddInfoDiv = document.getElementById('QuickAddInfoSdev');
      if (quickAddInfoDiv) {
        quickAddInfoDiv.innerHTML = '';
      } else {
        console.log('Product form or QuickAddInfoSdev div not found');
      }
      const productUrl = event.target.getAttribute('href');
      console.log('Product URL:', productUrl);
      
      // Add 'open' attribute to the modal
      const modal = document.getElementById('QuickAdd_sdev');
      if (modal) {
       setTimeout(()=>{ modal.setAttribute('open', 'true');},1000);
      }

      fetchProductData(productUrl);
    });
  });

  // Close the modal when the close button is clicked
  const closeButton = document.querySelector('#ModalClose-');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      const modal = document.getElementById('QuickAdd_sdev');
      if (modal) {
        modal.removeAttribute('open');
      }
    });
  }
});

function fetchProductData(productUrl) {
  const controller = new AbortController();
  const signal = controller.signal;

  fetch(productUrl, {
    method: 'get',
    signal: signal
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.text();
    })
    .then((responseText) => {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = responseText;

      const productForm = tmpl.content.querySelector('.section-main-product');
      console.log('Product Form:', productForm);

      const quickAddInfoDiv = document.getElementById('QuickAddInfoSdev');
      if (quickAddInfoDiv && productForm) {
        quickAddInfoDiv.innerHTML = '';
        quickAddInfoDiv.appendChild(productForm);
      } else {
        console.log('Product form or QuickAddInfoSdev div not found');
      }

      const variantSwatchKing = tmpl.content.querySelector('variant-swatch-king');
      if (variantSwatchKing) {
        console.log('Variant Swatch:', variantSwatchKing);
      }

      const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const delayedContent = quickAddInfoDiv.querySelector('.delayed-content');
            if (delayedContent) {
              console.log('Delayed Content Detected:', delayedContent);
              quickAddInfoDiv.appendChild(delayedContent);
              observer.disconnect();
            }
          }
        });
      });

      observer.observe(quickAddInfoDiv, { childList: true, subtree: true });
    })
    .catch((error) => {
      console.error('Error fetching product data:', error);
    });
}
